/**
 * Plotea `/privacy` and `/terms` (public, linked from sign-in and the account
 * menu). Texts and draft status: lib/ploteaLegal.ts.
 */
import { Link } from '@tanstack/react-router'
import { PloteaWordmark } from '../components/Logo'
import {
  PLOTEA_LEGAL_DRAFT,
  PLOTEA_LEGAL_UPDATED,
  ploteaPrivacyPolicy,
  ploteaTerms,
} from '../lib/ploteaLegal'
import { TermsDocument } from './HostAnalyticsTerms'

/** Privacy policy and terms links, shared by the sign-in footer and the pages. */
export function PloteaLegalLinks({ className }: { className?: string }) {
  return (
    <nav className={className} aria-label="Dokumenty prawne">
      <Link to="/privacy" className="hover:text-foreground hover:underline">
        Polityka prywatności
      </Link>
      <span aria-hidden="true"> · </span>
      <Link to="/terms" className="hover:text-foreground hover:underline">
        Regulamin
      </Link>
    </nav>
  )
}

function PloteaLegalPage({ text, testId }: { text: string; testId: string }) {
  return (
    <main className="min-h-screen bg-background px-6" data-testid={testId}>
      <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 border-b py-4">
        <Link to="/site" aria-label="Plotea">
          <PloteaWordmark className="h-5 w-auto" />
        </Link>
        <span className="text-sm text-muted-foreground">
          Aktualizacja: {PLOTEA_LEGAL_UPDATED}
        </span>
      </div>
      {PLOTEA_LEGAL_DRAFT && (
        <p
          role="note"
          className="mx-auto mt-6 max-w-3xl rounded-[3px] border border-warning/40 bg-warning/10 px-4 py-3 text-sm text-foreground"
          data-testid="legal-draft"
        >
          Wersja robocza do zatwierdzenia. Dokument nie jest jeszcze
          obowiązującą wersją.
        </p>
      )}
      <TermsDocument text={text} />
      <PloteaLegalLinks className="mx-auto max-w-3xl border-t py-6 text-sm text-muted-foreground" />
    </main>
  )
}

export function PloteaPrivacyPage() {
  return <PloteaLegalPage text={ploteaPrivacyPolicy} testId="plotea-privacy" />
}

export function PloteaTermsPage() {
  return <PloteaLegalPage text={ploteaTerms} testId="plotea-terms" />
}
